export const BOOKING_PATH = '/booking';
export const SELF_SERVICE_PATH = '/selfservice';
export const LEGACY_SELF_SERVICE_PATH = '/appointment';
